import { BaseApi } from "./base.api";
import {
  TMRIRadarDefaultNegotiator,
  TMRIRadarNegotiatorRelationData,
} from "types/mri-radar.type";

export class AccountMRIRadarApi extends BaseApi {
  async fetchAccountMRIRadarNegotiatorRelations(
    accountId: number
  ): Promise<TMRIRadarNegotiatorRelationData[]> {
    return this.get(`/accounts/${accountId}/mri-radar/negotiator-relations`);
  }

  async updateAccountMRIRadarNegotiatorRelations(
    accountId: number,
    relationsData: TMRIRadarNegotiatorRelationData[]
  ) {
    await this.post(`/accounts/${accountId}/mri-radar/negotiator-relations`, {
      items: relationsData,
    });
  }

  async fetchMRIRadarDefaultNegotiator(
    accountId: number
  ): Promise<TMRIRadarDefaultNegotiator> {
    return this.get(`/accounts/${accountId}/mri-radar/default-negotiator`);
  }

  async updateMRIRadarDefaultNegotiator(
    accountId: number,
    mriNegotiatorEmail: string | null
  ) {
    await this.post(`/accounts/${accountId}/mri-radar/default-negotiator`, {
      mriNegotiatorEmail,
    });
  }
}
